import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
export default function RedirectNotepad() {
  const navigate = useNavigate();

  const randomWords = [
    "cook",
    "gift",
    "nothing",
    "shade",
    "right",
    "monkey",
    "rather",
    "enough",
    "obtain",
    "thou",
    "himself",
    "return",
    "football",
    "center",
    "last",
    "plural",
    "pick",
    "either",
    "managed",
    "ruler",
    "wooden",
    "winter",
    "black",
    "slowly",
    "heard",
    "job",
    "said",
    "salt",
    "birth",
    "move",
    "solid",
    "globe",
    "science",
    "he",
    "held",
    "during",
    "matter",
    "nearest",
    "differ",
    "flame",
    "pack",
    "watch",
    "needed",
    "boy",
    "six",
    "show",
    "telephone",
    "time",
    "buried",
    "tears",
    "judge",
    "tiny",
    "although",
    "respect",
    "wide",
    "simply",
    "lonely",
    "moment",
    "safe",
    "promised",
    "mice",
    "however",
    "search",
    "muscle",
    "zoo",
    "chain",
    "high",
    "shallow",
    "mouse",
    "building",
    "frighten",
    "snake",
    "string",
    "machine",
    "wife",
    "amount",
    "size",
    "except",
    "long",
    "led",
    "history",
    "this",
    "whole",
    "drove",
    "tin",
    "save",
    "man",
    "organization",
    "pretty",
    "goes",
    "fish",
    "interior",
    "be",
    "chapter",
    "duty",
    "gold",
    "long",
    "ship",
    "night",
    "under",
  ];

  function getRandomWord() {
    return randomWords[Math.floor(Math.random() * randomWords.length)];
  }

  useEffect(() => {
    let id = getRandomWord() + getRandomWord() + getRandomWord();
    return navigate("/" + id);
  }, []);
}
